<template>
  <analytics :poStillOpen="false"/>
</template>

<script>
export default {
  name: 'SupplierPoWoAnalyticsClose',
  components: {
    'analytics': () => import(/* webpackChunkName: 'RFQSupplierPoWoAnalytics' */ '@/components/Shared/RFQSupplierPoWoAnalytics')
  }
}
</script>
